var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 14.6666C8.91977 14.6666 9.66586 13.9206 9.66586 13H6.33409C6.33409 13.9206 7.08019 14.6666 7.99998 14.6666ZM13.6091 10.7679C13.106 10.2273 12.1646 9.41404 12.1646 6.74998C12.1646 4.72654 10.7458 3.10675 8.83279 2.70935V2.16665C8.83279 1.70649 8.45987 1.33331 7.99998 1.33331C7.54008 1.33331 7.16716 1.70649 7.16716 2.16665V2.70935C5.25414 3.10675 3.83539 4.72654 3.83539 6.74998C3.83539 9.41404 2.89399 10.2273 2.39086 10.7679C2.23461 10.9359 2.16534 11.1367 2.16664 11.3333C2.16951 11.7604 2.50466 12.1666 3.00258 12.1666H12.9974C13.4953 12.1666 13.8307 11.7604 13.8333 11.3333C13.8346 11.1367 13.7653 10.9357 13.6091 10.7679Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.0c3ad3e5f945da394d159823fc8d4936.svg";
export { ForwardRef as ReactComponent };